module.exports = __webpack_public_path__ + "img/projectList_bg15.a65c392d.png";